
import { Progress } from "@/components/ui/progress";

interface SeoAnalysisProgressProps {
  analyzing: boolean;
  progress: number;
  selectedTool: string;
}

export const SeoAnalysisProgress = ({ analyzing, progress, selectedTool }: SeoAnalysisProgressProps) => {
  if (!analyzing) return null;
  
  return (
    <div className="mb-8">
      <div className="flex justify-between mb-2 text-sm">
        <span>Analyzing your website...</span>
        <span>{progress}%</span>
      </div>
      <Progress value={progress} className="h-2" />
      <div className="mt-4 text-sm text-muted-foreground">
        <p className="animate-pulse">
          {selectedTool === "seo-analysis" && "Scanning meta tags, content quality, mobile usability, page speed, backlinks, keywords, competitor data, and more..."}
          {selectedTool === "keyword-research" && "Analyzing keyword rankings, search volume, competition, and opportunities..."}
          {selectedTool === "backlink-checker" && "Checking backlink profile, authority scores, referring domains, and link quality..."}
          {selectedTool === "site-speed" && "Testing page load times, core web vitals, mobile performance, and optimization opportunities..."}
        </p>
      </div>
    </div>
  );
};

export default SeoAnalysisProgress;
